import { render, staticRenderFns } from "./ClassesLinkManagerTableWidget.vue?vue&type=template&id=c6095a8c"
import script from "./ClassesLinkManagerTableWidget.vue?vue&type=script&lang=js"
export * from "./ClassesLinkManagerTableWidget.vue?vue&type=script&lang=js"
import style0 from "./ClassesLinkManagerTableWidget.vue?vue&type=style&index=0&id=c6095a8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports